module.exports = "/_next/static/images/nova-hero-desktop-1c43d0fe421be63627c45ae3d3980cc5.png";